/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {useSystemOfUnits} from '@ion/applications/src/hooks/useSystemOfUnits';
import {isCirus, isDickeyJohn, isForceAmerica, isRoadWatch} from '@ion/core/src/entities/Manufacturer';
import {GenericObject} from '@ion/core/src/types/entities';
import CirusCardListContent from './CirusCardListContent';
import DickeyJohnCardListContent from './DickeyJohnCardListContent';
import ForceAmericaCardListContent from './ForceAmericaCardListContent';

export interface ManufacturerSpreaderDetailsProps {
  measures: GenericObject;
  sensorType: string;
  translations: string | GenericObject;
}

const ManufacturerSpreaderDetails = ({
  measures,
  sensorType,
  translations
}: ManufacturerSpreaderDetailsProps) => {
  useSystemOfUnits();
  return (
    <>
      {isDickeyJohn(sensorType) && (
        <DickeyJohnCardListContent measures={measures} translations={translations} />
      )}
      {isForceAmerica(sensorType) && (
        <ForceAmericaCardListContent measures={measures} />
      )}
      {(isCirus(sensorType) || isRoadWatch(sensorType)) && (
        <CirusCardListContent measures={measures} />
      )}
    </>
  );
};

export default ManufacturerSpreaderDetails;
